<div class="scroll-to-top" [ngClass]="{'show': windowScrolled}">
    <button type="button" mat-icon-button
            [ngClass]="{'scrollTop': isScrollTop}"
            (click)="scrollTo()">
        <mat-icon [svgIcon]="'arrow_back'">
        </mat-icon>
    </button>
</div>
